// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import Trix from "trix"
import "@rails/actiontext"
import "./controllers"

Trix.config.blockAttributes.alignCenter = {
  tagName: "center",
  terminal: true,
  breakOnReturn: false,
  group: false
}
Trix.config.blockAttributes.alignJustify = {
  tagName: "text-align-justify",
  terminal: true,
  breakOnReturn: false,
  group: false
}
Trix.config.dompurify.ADD_TAGS = [
  ...(Trix.config.dompurify.ADD_TAGS || []),
  "text-align-justify"
]

document.addEventListener("trix-file-accept", (event) => event.preventDefault())
